import SvgIcon from '@mui/material/SvgIcon';

export function FaceIdIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Standard Face ID Line Art Path */}
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 7V5a2 2 0 0 1 2-2h2m10 0h2a2 2 0 0 1 2 2v2m0 10v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M8 11h.01M16 11h.01M9 16c.5 1.5 2.5 1.5 3 0"
      />
    </SvgIcon>
  );
}